import type { SpinnerProps } from '@/components/ui/spinner';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

export type LoadingContainerProps = {
  minHeight?: React.CSSProperties['minHeight'];
  spinnerProps?: SpinnerProps;
  className?: string;
};

function LoadingContainer({
  minHeight = '50vh',
  spinnerProps,
  className,
}: LoadingContainerProps) {
  return (
    <div
      data-slot="loading-container"
      className={cn(
        'mx-auto w-auto max-w-5xl px-5 py-3 sm:px-4 sm:py-2',
        className
      )}
    >
      <div
        className="flex flex-col items-center justify-center gap-5 sm:gap-4"
        style={{ minHeight }}
      >
        <Spinner {...spinnerProps} />
      </div>
    </div>
  );
}

export { LoadingContainer };
export default LoadingContainer;
